var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Bedankt voor het invullen van de vragenlijst.")]),_c('v-btn',{staticClass:"mt-4",attrs:{"large":"","href":"https://vigogroep.nl","color":"primary"}},[_vm._v("Sluiten")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }